<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.username')}}
                <el-form-item prop="name">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.name.value"
                    maxlength="50"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.email')}}
                <el-form-item prop="email">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.email.value"
                    maxlength="255"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <AccessibleElSelect
                v-model="form.role.value"
                prop="role"
                :options="rolesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersbygroupfilter"
                @select="handleSelectRole"
              >
                <template slot="label">{{$t('configurations.rol')}}</template>
              </AccessibleElSelect>
            </div>
            <div>
              <AccessibleElSelect
                v-model="form.tipoAuth.value"
                prop="tipoAuth"
                :options="tiposAuthForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersbygroupfilter"
                @select="handleSelectTipoAuth"
              >
                <template slot="label">{{$t('configurations.tipo_auth')}}</template>
              </AccessibleElSelect>
            </div>
             <div>
              <AccessibleElSelect
                v-model="form.verTodoStatuses.value"
                prop="verTodoStatuses"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersbygroupfilter"
              >
                <template slot="label">{{$t('configurations.ver_todo_statuses')}}</template>
              </AccessibleElSelect>
            </div>
             <div>
              <AccessibleElSelect
                v-model="form.verTodoCompanies.value"
                prop="verTodoCompanies"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersbygroupfilter"
              >
                <template slot="label">{{$t('configurations.ver_todo_companies')}}</template>
              </AccessibleElSelect>
            </div>
            <!--
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.company')}}
                <el-form-item prop="company">
                  <el-autocomplete class="w-full" v-model="form.company.value" clearable
                  :fetch-suggestions="querySearch"
                  @select="handleSelect">
                    </el-autocomplete>
                </el-form-item>
              </label>
            </div>
            -->
          </div>
          
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { TIPOS_AUTH } from '@/config/tipos-auth'
import { ROLES } from '@/config/roles'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'groupusers',
      isOpen: this.panelOpen,
      links: [],
      form: {
        id: { label: i18n.t('configurations.id'), value: '' },
        name: { label: i18n.t('configurations.username'), value: '' },
        email: { label: i18n.t('configurations.email'), value: '' },
        company: { label: i18n.t('configurations.company'), value: '' },
        verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
        verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
        role: { label: i18n.t('configurations.rol'), value: '' },
        tipoAuth: { label: i18n.t('configurations.tipo_auth'), value: '' },
      },
      tiposAuth: TIPOS_AUTH,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      valuesNombresTag: []
    }
  },

  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
  },
  computed: {
    rolesForAccessibleSelect: function () {
      return this.roles.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    tiposAuthForAccessibleSelect: function () {
      return this.tiposAuth.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.value,
        name: item.label
      }))
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    roles: function () {
      return ROLES.filter(r => {
        if (r.only) {
          return r.only.includes(this.role)
        }
        return true
      })
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.id.value = _temp.id !== undefined && _temp.id.value !== '' ? _temp.id.value : ''
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''
        this.form.company.value = _temp.company !== undefined && _temp.company.value !== '' ? _temp.company.value : ''
        this.form.verTodoStatuses.value = _temp.verTodoStatuses !== undefined && _temp.verTodoStatuses.value !== '' ? _temp.verTodoStatuses.value : ''
        this.form.verTodoCompanies.value = _temp.verTodoCompanies !== undefined && _temp.verTodoCompanies.value !== '' ? _temp.verTodoCompanies.value : ''
        this.form.role.value = _temp.role !== undefined && _temp.role.value !== '' ? _temp.role.value : ''
        this.form.tipoAuth.value = _temp.tipoAuth !== undefined && _temp.tipoAuth.value !== '' ? _temp.tipoAuth.value : ''
      }
    },
    watchFormHandler: function ({ certificate, send_alerts, automatic_download }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (automatic_download !== undefined) {
        this.form.automatic_download = !!automatic_download
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        id: { label: i18n.t('configurations.id'), value: '' },
        name: { label: i18n.t('configurations.username'), value: '' },
        email: { label: i18n.t('configurations.email'), value: '' },
        company: { label: i18n.t('configurations.company'), value: '' },
        verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
        verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
        role: { label: i18n.t('configurations.rol'), value: '' },
        tipoAuth: { label: i18n.t('configurations.tipo_auth'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect: function (item) {
      // console.log(item)
    },
    handleSelectTag: function (item) {
      // console.log('handleSelectTag', item)
      this.form.nombreTag.value = item.id
    },
    handleSelectRole: function (item) {
      this.form.role.value = item.id
    },
    handleSelectTipoAuth: function (item) {
      this.form.tipoAuth.value = item.id
    }
  }
}
</script>

<style lang="scss" scoped></style>
